import React from 'react';
import {_GPY,__GPYPost} from '../env.js'
import GpyModalAlert from '../scoreboard/gametypes/lib/GpyModalAlert'

class LoginLostPasswordForm extends React.Component  {

  constructor(props) {
   super(props);
   this.state = {
          email: "",
          _email: false,
          rmessage : "",
          eventHandler: {},
        };

        this.modalClose = this.modalClose.bind(this)
   }

   registerEvent(name,e) {
     var ev = this.state.eventHandler;
     ev[name] = e;
     this.setState({eventHandler:ev});
   }

   showModal(obj,t,b){
 		Object.keys(this.state.eventHandler).forEach(key => {
 				var c = this.state.eventHandler[key];
 				if(c !== undefined && c.showModal !== undefined){
 					c.showModal(obj,t,b);
 				}
 		});
 	}

  onChangeEmail(e){
    this.setState({email: e.target.value, _email: _GPY.isValidEmail(e.target.value)});
  }

  resetPassword() {

    if(this.state._email) {
      __GPYPost("doResetPassword",{email:this.state.email},(r) => {
        var title = _GPY.i18n.get('user_messages_password_reset_client_alert_title')
        var body = "";
        if(r.Result.state === 'SUCCESS') {
            body = r.Result.message;
        }
        if(r.Result.state === 'FAIL') {
            body = r.Result.message;
        }
        this.showModal(true,title,body);

      },(fail) => {

      });
    }
  }

  returnToLogin(){
    this.props.login.setCurrentForm("LoginForm");
  }

  modalClose() {
      this.returnToLogin();
  }

  render () {
	   return (
       <div>
				<div className="jumbotron">
        <div className="row">
           <div className="col"><h1 className="display-4">{_GPY.i18n.get('login_form_headLine')}</h1></div>
           <div className="col text-right"><img style={{maxWidth : '200px'}} src={_GPY.resource("images/guppyi_logo.png")} className="img-fluid mx-auto" alt="Guppyi Logo"/></div>
        </div>
				  <p className="lead">{_GPY.i18n.get('lostpassword_form_subHeadLine')}</p>
				  <hr className="my-4"/>

  						  <div className="form-group">
  						    <label htmlFor="inputEmail">{_GPY.i18n.get('lostpassword_form_input_email_title')}</label>
  				 		    <input name="login_email" onChange={this.onChangeEmail.bind(this)} value={this.state.email} type="email" className="form-control" placeholder={_GPY.i18n.get('lostpassword_form_input_email_placeholder')}/>
                  {!this.state._email&&this.state.email!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_invalid_email')}</small>:""}
                  </div>
        	 		 <div className="row">
  					 		<div className="col">
                  <button className="btn btn-light btn-lg" onClick={this.returnToLogin.bind(this)}>{_GPY.i18n.get('lostpassword_form_button_login')}</button>
  				 		 	</div>
  				 		 	<div className="col">
  				 		 		<div className="float-right">
                  {this.state._email?
  				 		 			  <button onClick={this.resetPassword.bind(this)} className="btn btn-primary btn-lg">{_GPY.i18n.get('lostpassword_form_button_lostpassword')}</button>
                  :
                    	<button className="btn btn-primary btn-lg disabled">{_GPY.i18n.get('lostpassword_form_button_lostpassword')}</button>
                  }
  				 		 		 </div>
  				 		 	</div>
  				 		  </div>
				</div>
        <GpyModalAlert parent={this} icon="check" text="body" close={this.modalClose}/>
        </div>
	  	)
  }
}
export default LoginLostPasswordForm;
